import { apiCall, API, NEW_BE_API } from '../../utils/APIFunctions';

export function fetch(companyId, hide_deleted = true) {
  let hideDeleted = hide_deleted ? '&hide_deleted=true' : '';
  return apiCall(`${API}/users?company_id=${companyId}${hideDeleted}`, "GET");
}

export function listForManager(objectId) {
  return apiCall(`${API}/users/list-for-manager/${objectId}`, "GET");
}

export function toggleEditorRightsForUser(userId) {
  return apiCall(`${API}/users/${userId}/editor_rights`,"post");
}

export function toggleAdminRightsForUser(userId) {
  return apiCall(`${NEW_BE_API}/api/n1/users/${userId}/toggle-admin`,"post");
}

export function hasActiveApiKeys(userId) {
  return apiCall(`${NEW_BE_API}/api/n1/users/${userId}/has-active-api-keys`,"GET");
}

export function getUserObjects(userId) {
  return apiCall(`${API}/users/${userId}/objects`,"get");
}

export function getUserGroupsForUser(userId) {
  return apiCall(`${NEW_BE_API}/api/n1/users/${userId}/usergroups`,"get");
}

export function sendInvite(params) {
  return apiCall(`${NEW_BE_API}/api/n1/companies/invite`,"post", JSON.stringify(params));
}

export function removeUserFromCompany(params) {
  let data = {
    remove_shares: params.removeShares,
    update_owner: 1,
    new_owner_id: params.newOwnerId
  };

  return apiCall(`${NEW_BE_API}/api/n1/users/${params.userId}`, "delete", JSON.stringify(data));
}

export function restrictShares(params) {
  return apiCall(`${API}/user-management/restrict-shares/${params.newLevel}`, "put",
    JSON.stringify({userIds: params.userIds}));
}

export function sendSsoInvite(userId) {
  return apiCall(`${NEW_BE_API}/api/n1/companies/send-sso-invite`, "post", JSON.stringify({user_id: userId}));
}
